import React from 'react';
import DriverMap from '../../../../../modules/Dispatch/RouteExecution/DriverMap';
import { useSelectDriversContext } from '../SelectDriversContext';
import { selectDriversMapConfig } from './config/selectDriversMapConfig';

/** glContainer-shaped object so DriverMapContent can use gridHeader_${glContainer._config.id} */
const selectDriversGlContainer = {
  _config: { id: selectDriversMapConfig.mapHeaderId },
};

const MapSection: React.FC = () => {
  const { selectedDriverIds, selectedPickupsList, userData, glEventHub, configJSON } = useSelectDriversContext();
  const selectedPickupIds = (selectedPickupsList ?? [])
    .map((p: { pickupId?: string }) => p.pickupId)
    .filter(Boolean) as string[];
  return (
    <DriverMap
      userData={userData}
      glEventHub={glEventHub}
      configJSON={configJSON}
      glContainer={selectDriversGlContainer}
      pickupOptimizationParams={{
        overrideDriverIds: selectedDriverIds,
        selectedPickupIds,
      }}
      mapContainerId={selectDriversMapConfig.mapContainerId}
      mapId={selectDriversMapConfig.mapId}
    />
  );
};

export default MapSection;
